import { DatePicker, FilterButton } from '@vake/ui-kit';
import { FC } from 'react';

type Props = {
    subscriptionStart: Date | undefined;
    subscriptionEnd: Date | undefined;
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (date: Date | null) => void;
    setEndDate: (date: Date | null) => void;
    useDateInterval: boolean;
};
export const Calendar: FC<Props> = ({
    subscriptionStart,
    subscriptionEnd,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    useDateInterval,
}) => {
    return (
        <>
            <div className="flex gap-2">
                <DatePicker
                    selectedDate={startDate}
                    setSelectedDate={setStartDate}
                    minDate={subscriptionStart}
                    maxDate={subscriptionEnd}
                    popperPlacement="bottom-start"
                    disableTyping
                />
                {useDateInterval && (
                    <DatePicker
                        selectedDate={endDate}
                        setSelectedDate={(date) => {
                            date?.setHours(23, 59);
                            setEndDate(date);
                        }}
                        minDate={subscriptionStart}
                        maxDate={subscriptionEnd}
                        disableTyping
                    />
                )}
            </div>
            {!useDateInterval && (
                <div className="flex py-1 gap-2 justify-between max-w-[229px]">
                    <FilterButton
                        subtle
                        onClick={() => {
                            if (startDate) {
                                const newDate = new Date(startDate);
                                newDate.setDate(newDate.getDate() - 1);
                                const tempSubscriptionStart = subscriptionStart && new Date(subscriptionStart);
                                if (tempSubscriptionStart) {
                                    tempSubscriptionStart.setHours(0, 0);
                                }
                                if (tempSubscriptionStart && tempSubscriptionStart <= newDate) {
                                    setStartDate(newDate);
                                }
                            }
                        }}
                    >
                        Previous
                    </FilterButton>
                    <FilterButton
                        subtle
                        onClick={() => {
                            if (startDate) {
                                const newDate = new Date(startDate);
                                newDate.setDate(newDate.getDate() + 1);
                                if (subscriptionEnd === undefined || (subscriptionEnd && newDate <= subscriptionEnd)) {
                                    setStartDate(newDate);
                                }
                            }
                        }}
                    >
                        Next
                    </FilterButton>
                </div>
            )}
        </>
    );
};
